const key = ['CommandBar', 'CommandBarApp'].includes(process.env.REACT_APP_FRAME_NAME ?? 'CommandBar')
  ? 'CommandBar'
  : `CommandBar${process.env.REACT_APP_FRAME_NAME}`;
(window as any)[key] = (window as any)[key] || {};
export default (window as any)[key];
